const BASE_URL = process.env.REACT_APP_INTERVIEW_API_BASE_URL || 'http://110.183.1.90:8007';

const getToken = () => localStorage.getItem('access_token');

export interface InterviewQuestion {
  question: string;
  type?: string;
  difficulty?: string;
}

export interface SkillQuestions {
  skill: string;
  questions: InterviewQuestion[];
}

export interface InterviewQuestionsResponse {
  job_id?: string;
  resume_id?: string;
  skills: SkillQuestions[];
  total_questions?: number;
  total_skills?: number;
  skills_with_questions?: number;
  skills_without_questions?: number;
}

// API raw response format
interface InterviewQuestionsApiResponse {
  skill_questions: Record<string, string | string[]>;
  total_skills?: number;
  skills_with_questions?: number;
  skills_without_questions?: number;
}

export const interviewService = {
  // Get interview questions by job_id and resume_id
  getInterviewQuestions: async (jobId: string, resumeId: string): Promise<InterviewQuestionsResponse> => {
    const token = getToken();
    
    if (!token) {
      throw new Error('No authentication token found');
    }

    try {
      console.log('[InterviewService] Fetching interview questions for:', { jobId, resumeId });
      
      const url = `${BASE_URL}/agent/questions?job_id=${jobId}&resume_id=${resumeId}`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'accept': 'application/json',
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('[InterviewService] API Error Response:', errorText);
        throw new Error(`Failed to fetch interview questions: ${response.status} ${response.statusText}`);
      }

      const data: InterviewQuestionsApiResponse = await response.json();
      console.log('[InterviewService] Interview questions raw response:', data);
      
      // Transform the response to match our expected format
      const transformedData: InterviewQuestionsResponse = {
        job_id: jobId,
        resume_id: resumeId,
        skills: [],
        total_skills: data.total_skills,
        skills_with_questions: data.skills_with_questions,
        skills_without_questions: data.skills_without_questions,
      };

      // Transform skill_questions object to skills array
      if (data.skill_questions && typeof data.skill_questions === 'object') {
        transformedData.skills = Object.entries(data.skill_questions).map(([skill, questionData]) => {
          // Handle both string and array formats
          const questions: InterviewQuestion[] = Array.isArray(questionData)
            ? questionData.map(q => ({ question: q }))
            : [{ question: questionData }];
          
          return {
            skill,
            questions,
          };
        });

        // Calculate total questions
        transformedData.total_questions = transformedData.skills.reduce(
          (sum, skillData) => sum + skillData.questions.length,
          0
        );
      }

      console.log('[InterviewService] Transformed data:', transformedData);
      
      return transformedData;
    } catch (error) {
      console.error('[InterviewService] Error fetching interview questions:', error);
      throw error;
    }
  },
};

